module.exports = __webpack_public_path__ + "img/jwgl-xk-xgk.faf8ae02.png";